import React from "react";
import "./Products.css";
import playstore from '../static/playstore.svg';
import appstore from '../static/appstore.svg';

export default function Products(){
    return(
        <div className="products-section" id="products">
            <div className="products-container">
                <div className="products-header">
                    <h2>Our Products</h2>
                    <p className="products-subtitle">Innovative solutions we've built and manage</p>
                </div>
                <div className="products-grid">
                    <div className="product-card homoeomend-card">
                        <div className="product-header">
                            <div className="product-icon">🏥</div>
                            <div className="product-info">
                                <h3>Homoeomend</h3>
                                <p className="product-tagline">Healthcare Reimagined</p>
                            </div>
                        </div>
                        <div className="product-content">
                            <p className="product-description">
                                A comprehensive homoeopathic healthcare platform connecting patients with qualified doctors. 
                                Pre-book appointments, get consultations, and manage your health journey with ease.
                            </p>
                            <div className="product-features">
                                <span className="feature-tag">Patient Booking</span>
                                <span className="feature-tag">Doctor Consultation</span>
                                <span className="feature-tag">Health Management</span>
                            </div>
                            <div className="product-actions">
                                <button className="product-btn primary">Learn More</button>
                                <div className="app-badges">
                                    <img src={playstore} alt="Google Play" className="app-badge"/>
                                    <img src={appstore} alt="App Store" className="app-badge"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="product-card dhanfree-card">
                        <div className="product-header">
                            <div className="product-icon">💰</div>
                            <div className="product-info">
                                <h3>Dhanfree</h3>
                                <p className="product-tagline">Smart Financial Planning</p>
                            </div>
                        </div>
                        <div className="product-content">
                            <p className="product-description">
                                Your trusted financial companion for smart money management, investment tracking, 
                                and comprehensive financial planning tools designed for the modern user.
                            </p>
                            <div className="product-features">
                                <span className="feature-tag">Money Management</span>
                                <span className="feature-tag">Investment Tracking</span>
                                <span className="feature-tag">Financial Planning</span>
                            </div>
                            <div className="product-actions">
                                <button 
                                    className="product-btn primary" 
                                    onClick={() => window.open('https://dhanfree.com', '_blank')}
                                >
                                    Visit Dhanfree.com
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="products-cta">
                    <h3>Have a Product Idea?</h3>
                    <p>We help bring your digital product vision to life. From concept to launch and beyond.</p>
                    <button className="cta-button" onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}>
                        Explore Our Development Services
                    </button>
                </div>
            </div>
        </div>
    )
}